export default function TrustBadges() {
  const badges = [
    {
      icon: 'ri-flask-line',
      title: 'Research Use Only',
      description: 'Laboratory applications'
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Quote-Based Ordering',
      description: 'Manual approval required'
    },
    {
      icon: 'ri-test-tube-line',
      title: 'Third-Party Tested',
      description: 'COA documentation available'
    },
    {
      icon: 'ri-building-line',
      title: 'B2B Supply',
      description: 'Qualified institutions only'
    }
  ];

  return (
    <section className="section-sm bg-gray-50 border-y border-gray-200">
      <div className="container-custom">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-6">
          {badges.map((badge, index) => (
            <div key={index} className="flex flex-col items-center text-center">
              <div className="w-14 h-14 flex items-center justify-center bg-primary-50 rounded-xl mb-4 border border-primary-100">
                <i className={`${badge.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="text-sm font-bold text-navy-900 mb-1.5">{badge.title}</h3>
              <p className="text-xs text-navy-600 leading-relaxed">{badge.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}